<template>
  <select
    :id="id"
    :name="name"
    v-model="selected"
    :class="{ error: $v.$error }"
    :disabled="disabled"
    @change="onChange"
    @focus="(e) => { $emit('focus', e) }"
    @blur="(e) => { $emit('blur', e) }"
  >
    <option
      v-for="option in options"
      :key="option.value"
      :value="option.value"
      :selected="option.value === value"
    >{{ option.text }}
    </option>
  </select>
</template>

<script>
/* @flow */
import ValidationMessageList from '../ValidationMessageList'

export default {
  name: 'SelectInput',
  components: {
    ValidationMessageList
  },
  props: {
    $v: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: this.value
    }
  },
  watch: {
    value: function (value) {
      this.selected = value
    }
  },
  methods: {
    onChange (e) {
      this.$emit('change', e.target.value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/fields/SelectInput.vue